var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBestSellerSecond = function SvgBestSellerSecond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 45,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BestSellerSecond_svg__a)",
    d: "M0 3.5A3.5 3.5 0 0 1 3.5 0h29A3.5 3.5 0 0 1 36 3.5v38.74a1.75 1.75 0 0 1-2.497 1.582L0 28.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BestSellerSecond_svg__b)",
    d: "M0 3.5A3.5 3.5 0 0 1 3.5 0h29A3.5 3.5 0 0 1 36 3.5v24.519L2.497 43.822A1.75 1.75 0 0 1 0 42.24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.976 27H12.46v-2.116l.087-.131q1.376-1.767 2.618-3.317a799 799 0 0 0 1.637-2.007q1.44-1.767 2.094-2.596.655-.85.982-1.484.328-.654.328-1.2 0-.785-.59-1.418-.588-.633-1.592-.633-1.157 0-1.899.764-.741.763-.741 1.942v.458h-2.662v-.458q0-1.44.633-2.597a4.7 4.7 0 0 1 1.81-1.81q1.157-.678 2.64-.677h.022q2.05 0 3.36 1.004 1.33.981 1.637 2.552.087.415.087.895 0 .807-.327 1.593a8.6 8.6 0 0 1-.851 1.549 38 38 0 0 1-1.55 2.05 71 71 0 0 0-1.941 2.532q-.393.545-.895 1.2-.501.632-.698.872l-.502.633h6.83z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "BestSellerSecond_svg__a",
    x1: 25.5,
    x2: 31.302,
    y1: 33,
    y2: 45.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8792AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BestSellerSecond_svg__b",
    x1: 7.875,
    x2: 26.056,
    y1: 0,
    y2: 35.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#DEE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#ACB7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#8A9AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96A3BE"
  })))));
};
export default SvgBestSellerSecond;